import React from 'react'
import { Query } from 'react-apollo'
import { Col, Upload, Select } from 'antd'
import * as UI from 'konsys-ui'
import moment from 'moment'
import _ from 'lodash'
import { detailMode } from '../constants'
import { DatePicker, AutoComplete } from '../styled'
import { checkInt, checkFloat } from '../../../utils/util-services'
import { GET_FLEETS } from '../../../constants/graphql/query'
import { UploadWithModal } from '../../../components/common'

/*
date.type is type of component
0: InputWithLabel
1: input
2: Text (P)
3: Dropdown (Select)
4: Radio box
5: Upload box
6: Button
7: Date picker
8: Autocomplete
9: Select
*/

const CreateMode = ({ data, plateNumList, onChangeHandler }) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span} offset={data.offset}><UI.InputWithLabel {...data.props} width='100%' input={{
          onChange: e => onChangeHandler(data.id, e.target.value),
          onKeyDown: (e) => {
            if (data.dataType === 'int' && !checkInt(e)) {
              e.preventDefault()
            }
            if (data.dataType === 'float' && !checkFloat(e)) {
              e.preventDefault()
            }
          },
          ...data.props.input,
          type: data.dataType === 'int' ? 'number' : data.dataType === 'float' ? 'number' : 'text',
          step: data.dataType === 'int' ? '1' : data.dataType === 'float' ? '0.01' : undefined,
          min: '0',
        }} /></Col>
      )
    case 1:
      return <UI.Input {...data.props} />
    case 2:
      return <UI.P {...data.props}>{data.label}</UI.P>
    case 3:
      return <UI.Select dropdown buttonProps={{ style: { height: '34px', padding: '4px 24px' }, text: data.children[0].text }} data={data.children} {...data.props} />
    case 4:
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ alignSelf: 'flex-end', margin: '0 0 16px 0' }}
        >
          <UI.RadioGroup {...data.props} list={data.list} defaultCheckedValue={data.list[0].value} vertical={data.isVertical} onChange={e => onChangeHandler(data.id, e.target.value)} />
        </Col>
      )
    case 5:
      return (
        <Col span={data.span} offset={data.offset}>
          <UploadWithModal
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => v.originFileObj))}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            listType='picture'
            button={data.props}
          />
        </Col>
      )
    case 7:
      return (
        <Col
          span={data.span}
          style={{ alignSelf: 'flex-end' }}
        >
          <UI.P>{data.label}</UI.P>
          <DatePicker onChange={e => onChangeHandler(data.id, moment(e).format('YYYY-MM-DD'))} {...data.props}/>
        </Col>
      )
    case 8: // only fleet
      return (
        <Query
          query={GET_FLEETS}
        >{({ data: fleetData, loading, error }) => {
          if (loading) return <UI.Loading />
          if (error) return <UI.P>เกิดข้อผิดพลาด</UI.P>
          return (
            <Col
              span={data.span}
              style={{ alignSelf: 'flex-end', padding: '0 6px 8px' }}
            >
              <UI.P margin='0 0 16px'>{data.label}</UI.P>
              <AutoComplete
                {...data.props}
                dataSource={fleetData.FleetList.lists.map(v => v.name)}
                style={{ width: '100%' }}
                onSelect={e => onChangeHandler(data.id, e)}
                onSearch={e => onChangeHandler(data.id, e)}
                filterOption={(inputValue, option) => option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
              />
            </Col>
          )
        }}
        </Query>
      )
    case 9:
      return (
        <Col
        span={data.span}
        style={{}}
      >
        <UI.Div display='flex' flexDirection='column' margin='0'>
          <UI.P margin='8px 0 16px'>{data.label}</UI.P>
          <Select
            showSearch
            onChange={(e) => {
              onChangeHandler(data.id, e)
            }}
          >
          {
            plateNumList.map((v, i) => <Select.Option key={i} value={v}>{v}</Select.Option>)
          }
          </Select>
        </UI.Div>
      </Col>
      )
    case 10:
      return (
        <Col
          span={data.span}
          offset={data.offset}
          style={{ alignSelf: 'flex-end' }}
        >
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='8px 0 16px'>{data.props.title.text}</UI.P>
            <Select
              width='100%'
              onChange={e => onChangeHandler('companyType', e)}
            >
              <Select.Option value='PADOONGRICH'>บริษัท ผดุงฤทธิ์ขนส่ง จำกัด</Select.Option>
              <Select.Option value='TRANSPORT'>บริษัท ทรานสปอร์ตเตชั่น เน็ตเวิร์ค จำกัด</Select.Option>
            </Select>
          </UI.Div>
        </Col>
      )
    default:
      return <p>No type</p>
  }
}

const EditMode = ({
  data, disabled, initialData, onChangeHandler, plateNumList,
}) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.InputWithLabel width='100%' {...data.props} input={{
            disabled,
            defaultValue: initialData[data.id],
            onChange: e => onChangeHandler(data.id, e.target.value),
            onKeyDown: (e) => {
              if (data.dataType === 'int' && !checkInt(e)) {
                e.preventDefault()
              }
              if (data.dataType === 'float' && !checkFloat(e)) {
                e.preventDefault()
              }
            },
            ...data.props.input,
            type: data.dataType === 'int' ? 'number' : data.dataType === 'float' ? 'number' : 'text',
            step: data.dataType === 'int' ? '1' : data.dataType === 'float' ? '0.01' : undefined,
            min: '0',
          }} />
        </Col>
      )
    case 1:
      return <UI.Input disabled={disabled} {...data.props} defaultValue={initialData[data.id]} onChange={e => onChangeHandler(data.id, e.target.value)} />
    case 2:
      return <UI.P {...data.props}>{data.label}</UI.P>
    case 3:
      return (
        <UI.Select
          dropdown
          buttonProps={{ style: { height: '34px', padding: '4px 24px' }, text: initialData[data.id] }}
          data={data.children}
          disabled={disabled} {...data.props}
        />
      )
    case 4:
      return (
        <Col
          span={data.span} offset={data.offset}
          style={{ alignSelf: 'flex-end', margin: '0 0 16px 0' }}
        >
          <UI.RadioGroup
            disabled={disabled}
            list={data.list}
            defaultCheckedValue={initialData[data.id]}
            vertical={data.isVertical}
            onChange={e => onChangeHandler(data.id, e.target.value)}
            {...data.props}
          />
        </Col>
      )
    case 5:
      return (
        <Col span={data.span} offset={data.offset}>
          <UploadWithModal
            disabled={disabled}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            defaultFileList={initialData[data.id].map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))}
            listType='picture'
            button={data.props}
          />
        </Col>
      )
    case 7:
      return (
          <Col
            span={data.span}
            style={{ alignSelf: 'flex-end', marginTop: 8 }}
          >
            <UI.P>{data.label}</UI.P>
            <DatePicker
              onChange={e => onChangeHandler(data.id, moment(e).format('YYYY-MM-DD'))}
              disabled={disabled}
              defaultValue={_.isNull(initialData[data.id]) ? initialData[data.id] : moment(initialData[data.id])}
              {...data.props}
            />
          </Col>
      )
    case 8: // only fleet
      return (
        <Query
          query={GET_FLEETS}
        >{({ data: fleetData, loading, error }) => {
          if (loading) return <UI.Loading />
          if (error) return <UI.P>เกิดข้อผิดพลาด</UI.P>
          return (
            <Col
              span={data.span}
              style={{ alignSelf: 'flex-end', padding: '0 6px 8px' }}
            >
              <UI.P margin='0 0 16px'>{data.label}</UI.P>
              <AutoComplete
                {...data.props}
                disabled={disabled}
                dataSource={fleetData.FleetList.lists.map(v => v.name)}
                defaultValue={initialData[data.id]}
                style={{ width: '100%' }}
                onSelect={e => onChangeHandler(data.id, e)}
                onSearch={e => onChangeHandler(data.id, e)}
                filterOption={(inputValue, option) => option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
              />
            </Col>
          )
        }}
        </Query>
      )
    case 9:
      return (
        <Col
          span={data.span}
          style={{}}
        >
          <UI.Div display='flex' flexDirection='column' margin='0'>
            <UI.P margin='8px 0 16px'>{data.label}</UI.P>
            <Select
              showSearch
              disabled={disabled}
              defaultValue={initialData[data.id]}
              onChange={(e) => {
                onChangeHandler(data.id, e)
              }}
            >
            {
              plateNumList.map((v, i) => <Select.Option key={i} value={v}>{v}</Select.Option>)
            }
            </Select>
          </UI.Div>
        </Col>
      )
    case 10:
      return (
        <Col
          span={data.span}
          offset={data.offset}
          style={{ alignSelf: 'flex-end' }}
        >
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='8px 0 16px'>{data.props.title.text}</UI.P>
            <Select
              width='100%'
              disabled={true}
              defaultValue={initialData?.companyType}
              onChange={e => onChangeHandler('companyType', e)}
            >
              <Select.Option value='PADOONGRICH'>บริษัท ผดุงฤทธิ์ขนส่ง จำกัด</Select.Option>
              <Select.Option value='TRANSPORT'>บริษัท ทรานสปอร์ตเตชั่น เน็ตเวิร์ค จำกัด</Select.Option>
            </Select>
          </UI.Div>
        </Col>
      )
    default:
      return <p>no type</p>
  }
}

export default ({
  data, mode, onChangeHandler, initialData, plateNumList,
}) => {
  switch (mode) {
    case detailMode.ADD:
      return <CreateMode data={data} plateNumList={plateNumList} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    case detailMode.EDIT:
      return <EditMode data={data} plateNumList={plateNumList} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    case detailMode.VIEW:
      return <EditMode data={data} plateNumList={plateNumList} disabled={true} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    default:
      return <p>no mode</p>
  }
}
